import $ from 'jquery';

$(function () {
    /**
     * Toggle password visibility
     */
    (function () {
        $(document).on('click', 'a.toggle-password', function (e) {
            e.preventDefault();
            let input = $(this).closest('.input-group').find('input.form-control');
            if (input.is(':disabled')) {
                return false;
            }

            if (input.attr('type') === 'password') {
                input.attr('type', 'text').one('blur', function (e) {
                    if (e.relatedTarget && $(e.relatedTarget).is('a.toggle-password')) {
                        return;
                    }
                    $(this).attr('type', 'password');
                    e.stopPropagation();
                });
            } else {
                input.attr('type', 'password');
            }
            input.trigger('focus');
            return false;
        });
    })();
});